import React from "react"
import styled from "styled-components"
import UserInfo from "./userInfo"
import HeaderBasket from "./headerBasket"
import { WebView } from "../styles/common"
import { isAuthenticated } from "../utils/utils"

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: .2rem;
  /* background-color: #e8171e; */
  /* background-color: #f90406; */
  /* background-color: #ef0a0a; */
  background-color: #fa0404;
  padding: .8rem 1rem;
  @media (min-width: 768px) {
    padding: 1.2rem 1.6rem  1.2rem 2rem;
  }
`

const Divider = styled.div`
  border-left: 1px #fff solid;
  height: 2rem;
  margin: 0.8rem 0;
`

const CartAndBoxAccountBox = styled.div`
  position: relative;
  @media (min-width: 768px) {
    z-index: 10000;
  }
`

const CartAccountBox = ({ cartPop, hideCartPop, location }) => {
  return (
    <CartAndBoxAccountBox>
      <Container>
        <HeaderBasket cartPop={cartPop} hideCartPop={hideCartPop} />
        <WebView>
          {
            isAuthenticated() && (
              <>
                <Divider />
                <UserInfo />
              </>
            )
          }

        </WebView>
      </Container>
    </CartAndBoxAccountBox>
  )
}

export default CartAccountBox
